module.exports = __webpack_public_path__ + "af5fc776248ae7914117c6cd315ec8bd.png";